export default __webpack_public_path__ + "img/player-count-medium.daf5475f.svg";